import React, { useState, useEffect } from 'react';

const SCATimer = ({ durationSeconds = 720, onTimeUp, onTick, isPaused = false }) => {
    const [remaining, setRemaining] = useState(durationSeconds);

    useEffect(() => {
        // Reset if duration changes
        setRemaining(durationSeconds);
    }, [durationSeconds]);

    useEffect(() => {
        if (isPaused || remaining <= 0) return;

        const interval = setInterval(() => {
            setRemaining(prev => {
                const newVal = prev - 1;
                if (onTick) onTick(durationSeconds - newVal); // elapsed
                if (newVal <= 0) {
                    onTimeUp?.();
                    return 0;
                }
                return newVal;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [isPaused, remaining, durationSeconds, onTick, onTimeUp]);

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    const isWarning = remaining <= 120 && remaining > 60;
    const isCritical = remaining <= 60;

    return (
        <div className={`sca-timer ${isCritical ? 'critical' : isWarning ? 'warning' : 'normal'}`} style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: isCritical ? '#dc3545' : isWarning ? '#ffc107' : '#28a745',
            fontFamily: 'monospace',
            padding: '8px 16px',
            borderRadius: '8px',
            background: 'rgba(0,0,0,0.05)',
            display: 'inline-block'
        }}>
            {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </div>
    );
};

export default SCATimer;
